/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Card_Ai_Free_ValueInputs */



/**
* | output |
* | --- |
* | "Daily usage allowance" |
*
* @param {Plan_Card_Ai_Free_ValueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_ai_free_value = /** @type {((inputs?: Plan_Card_Ai_Free_ValueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Ai_Free_ValueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tägliches Nutzungsguthaben")
	return /** @type {LocalizedString} */ ("Daily usage allowance")
});